<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import NervenetFrame from './NervenetFrame.vue';

const props = defineProps({
  page: {
    type: String,
    default: 'calendar',
  },
});

const { accountId } = useAccount();

// Staff and Services no longer have their own sidebar entry or route — they're
// reached via the subnav rendered inside Nervenet's own booking pages, a
// normal link inside this already-loaded iframe (see
// nervenet/app/views/booking/_subnav.html.erb).
const PAGE_PATHS = {
  calendar: 'booking/calendar',
  business: 'booking/settings/business/edit',
};

const bookingUrl = computed(() => {
  const path = PAGE_PATHS[props.page] || PAGE_PATHS.calendar;
  return `${window.chatwootConfig.nervenetBaseUrl}/accounts/${accountId.value}/${path}`;
});
</script>

<template>
  <div class="w-full h-full">
    <NervenetFrame :src="bookingUrl" />
  </div>
</template>
